import { jsx as _jsx } from "react/jsx-runtime";
import { parse, startOfDay } from 'date-fns';
import { useContext } from 'react';
import styled from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { DatePickerFooter } from 'syf-component-library/ui/patterns/DatePicker';
import { formatDateObjectToString, formatDateStringToObject } from 'syf-js-utilities/formats';
import { FAL_CALENDAR_EXCLAMATION, FAR_CALENDAR_DAYS } from '../../../../const/iconProps';
import MainContext from '../../../../Context';
import { getEndDateForPayment, getEstDateObject, isPayLaterProduct } from '../../../../helpers';
import useApiMachine from '../../../../hooks/machines/useApiMachine';
import { t } from '../../../../strings/i18n';
import { useField } from '../../../../xform';
import { PaymentDatePicker, SelectWrapper } from '../subcomponents';
import { getHighlightedDates } from './helpers';
const CalendarIcon = styled(FontAwesomeIcon) `
  padding: 1px 4px;
`;
const PaymentDateSelect = ({ id }) => {
    const { featureFlags } = useContext(MainContext);
    const paymentDate = useField('paymentDate');
    const [apiMachine] = useApiMachine();
    const { data: accountSummary } = apiMachine.context.accountSummaryQueryResult;
    const { billing: { daysDelinquent, nextPaymentDate: dueDate }, product } = accountSummary;
    const { type: productType } = product;
    const isProductInstallmentEnterprise = isPayLaterProduct(productType);
    const datepickerEndDate = getEndDateForPayment(daysDelinquent, product);
    const handleDateChange = (date) => {
        if (date && date.toJSON()) {
            paymentDate.setValue(formatDateObjectToString(startOfDay(date)));
            paymentDate.blur();
            return;
        }
        paymentDate.setValue(null);
        paymentDate.blur();
    };
    return (_jsx(SelectWrapper, Object.assign({ horizontal: "medium" }, { children: _jsx(PaymentDatePicker, Object.assign({ boundarySelector: "#make-a-payment", calendarIcon: paymentDate.error ? (_jsx(CalendarIcon, { icon: FAL_CALENDAR_EXCLAMATION, size: "lg" })) : (_jsx(CalendarIcon, { icon: FAR_CALENDAR_DAYS, size: "lg" })), className: "PaymentDatePicker", endDate: datepickerEndDate, error: paymentDate.error, handleOnChange: handleDateChange, helpText: t('label.oneTimePaymentDateSelectHelpText'), highlightDateThemeArr: getHighlightedDates(featureFlags, accountSummary.billing.pastDue, dueDate), idTextField: id, isReadOnly: isProductInstallmentEnterprise, name: id, placeholderLabel: t('makePayment.paymentDate'), required: true, selectedDate: formatDateStringToObject(paymentDate.value), showMonthYearDropdown: true, startDate: startOfDay(getEstDateObject(new Date())), submitButtonCustomText: t('makePayment.submitButtonText'), onBlurHandler: (date) => {
                handleDateChange(parse(date, 'MM/dd/yyyy', new Date()));
            } }, { children: _jsx(DatePickerFooter, { bottomDisclaimerCopy: t('makePayment.makepaymentDisclaimer'), selectedDateText: t('makePayment.selectedPaymentDate'), showLegend: true }) })) })));
};
export default PaymentDateSelect;
